import React from 'react';
import '../styles/theme.css';
import '../styles/Dashboard.css';
import BruteHeader from '../components/BruteHeader';
import BruteFooter from '../components/BruteFooter';
import DashboardHubMasthead from '../components/DashboardHubMasthead';
import DashboardQuickRoutes from '../components/DashboardQuickRoutes';
import DashboardRecentRuns from '../components/DashboardRecentRuns';
import DashboardRunStats from '../components/DashboardRunStats';
/* IMPORTS */

function DashboardPage() {
  return (
    <div className="da-root">
      <div className="da-layout-1">
        <div id="dashboardheaderslot" className="da-slot-dashboardheaderslot">
          <BruteHeader activePage={"Dashboard"} />
        </div>
        <div className="da-layout-2">
          <div id="dashboardhubmasthead" className="da-slot-dashboardhubmasthead">
            <DashboardHubMasthead />
          </div>
          <div id="dashboardrunstats" className="da-slot-dashboardrunstats">
            <DashboardRunStats />
          </div>
          <div id="dashboardrecentruns" className="da-slot-dashboardrecentruns">
            <DashboardRecentRuns />
          </div>
          <div id="dashboardquickroutes" className="da-slot-dashboardquickroutes">
            <DashboardQuickRoutes />
          </div>
        </div>
        <div id="dashboardfooterslot" className="da-slot-dashboardfooterslot">
          <BruteFooter />
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;